import { h, Component } from 'preact';
import cx from 'classnames';

import style from './style.less';

import CardImage from '../../pieces/card-image';
import { isExternal, getCtaText, getHybridAttribution } from '../../../lib/utils';

import { trackingProvider, trackProps, getTrackingAttributesForAsset, DIMENSION } from '@cube/track';
import { assetLink } from '@cube/utils';

/**
 * A card with an image on left and text on right
 * @param {object} asset				the article to display
 * @param {string} theme				light or dark
 * @param {string} cardClass			fully resolved or local class to apply to card
 */
@trackingProvider({
	[DIMENSION.componentpath]: 'ResponsiveHorizontalCard'
})
export default class ResponsiveHorizontalCard extends Component {

	render({ asset, cardClass, qeId, ...props }) {
		let attribution = getHybridAttribution(asset);

		return (
			<div data-tb-region-item class={cx(style.horizontalCard, style[cardClass] || cardClass || '')} qid={qeId}>
				<a
					{...trackProps(getTrackingAttributesForAsset(asset), this.context)}
					href={assetLink(asset)}
					rel={isExternal(asset) && 'noreferrer noopener'}
					target={isExternal(asset) && '_blank'}
				>
					<CardImage
						asset={asset}
						qeId={qeId}
						{...props}
					/>
					<div class={style.metadata}>
						<div class={style.title} qid={qeId + '-title'}>
							{asset.title}
						</div>
						{ attribution &&
							<div class={style.attribution}>
								{ attribution }
							</div>
						}
						<div class={style.calltoaction}>
							{ getCtaText(asset) }
						</div>
					</div>
				</a>
			</div>
		);
	}
}
